import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import liveGameApi from "../../services/liveGameApi";
import { showErrorSnackbar, showSuccessSnackbar } from "./snackbarSlice";

export const getMessages = createAsyncThunk("liveGame/getMessages", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await liveGameApi.getMessages(data);
        if(response.status === 0){
            return response?.data?.messages;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message, position: { vertical: "bottom", horizontal: "left"} }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message, position: { vertical: "bottom", horizontal: "left"} }));
        return rejectWithValue(error.message);
    }
});

export const sendMessage = createAsyncThunk("liveGame/sendMessage", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await liveGameApi.sendMessage(data);
        if(response.status === 0){
            return response?.data;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message, position: { vertical: "bottom", horizontal: "left"} }));
            return rejectWithValue(response?.message);
        }
    }catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message, position: { vertical: "bottom", horizontal: "left"} }));
        return rejectWithValue(error.message);
    }
});

export const getLeaderboardDetails = createAsyncThunk("liveGame/getLeaderboardDetails", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await liveGameApi.getLeaderboardDetails(data);
        if(response.status === 0){
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message, position: { vertical: "bottom", horizontal: "left"} }));
            dispatch(resetLeaderboard());
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message, position: { vertical: "bottom", horizontal: "left"}}));
        dispatch(resetLeaderboard());
        return rejectWithValue(error.message);        
    }
});

export const getAllLeaderboardDetails = createAsyncThunk("liveGame/getAllLeaderboardDetails", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await liveGameApi.getAllLeaderboardDetails(data);
        if(response.status === 0){
            return response?.data;
        } else{
            dispatch(showErrorSnackbar({ title: response?.message, position: { vertical: "bottom", horizontal: "left"} }));
            dispatch(resetFullLeaderboard());
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({title: error?.message, position: { vertical: "bottom", horizontal: "left"}}));
        dispatch(resetFullLeaderboard());
        return rejectWithValue(error.message);        
    }
});

export const uploadMediaInLiveGame = createAsyncThunk("liveGame/uploadMediaInLiveGame", async ({ data, onProgress }, {rejectWithValue, dispatch}) => {
    try {       
        const response = await liveGameApi.uploadMediaInLiveGame(data, onProgress);
        if(response.status === 0){
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({title: error?.message}));
        return rejectWithValue(error.message);  
    }
});

export const restartLiveGame = createAsyncThunk("liveGame/restartLiveGame", async (data, {rejectWithValue, dispatch}) => {
    try {       
        const response = await liveGameApi.restartGame(data);
        if(response.status === 0){
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);  
    }
});

export const getGameActionsListCorrespondingToZone = createAsyncThunk("liveGame/getGameActionsListCorrespondingToZone", async (data, {rejectWithValue, dispatch}) => {
    try {       
        const response = await liveGameApi.getGameActionsListCorrespondingToZone(data);
        if(response.status === 0){
            return response?.data?.actionsList;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);  
    }
});

export const deleteLiveGameMedia = createAsyncThunk("liveGame/deleteLiveGameMedia", async (data, {rejectWithValue, dispatch}) => {
    try {       
        const response = await liveGameApi.deleteLiveGameMedia(data);
        if(response.status === 0){
            dispatch(showSuccessSnackbar({title: `File Deleted successfully`, position: { vertical: "bottom", horizontal: "left"}}))
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message, position: { vertical: "bottom", horizontal: "left"} }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({title: error?.message, position: { vertical: "bottom", horizontal: "left"}}));
        return rejectWithValue(error.message);  
    }
});

export const getLiveGameMediaList = createAsyncThunk("liveGame/liveGameMediaList", async (data, {rejectWithValue, dispatch}) => {
    try {     
        
        const response = await liveGameApi.getLiveGameMediaList(data);
        if(response.status === 0){
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message, position: { vertical: "bottom", horizontal: "left"} }));
            return rejectWithValue(response?.message);
        }
    } catch (error) {
        dispatch(showErrorSnackbar({title: error?.message, position: { vertical: "bottom", horizontal: "left"}}));
        return rejectWithValue(error.message);  
    }
});

const liveGameSlice= createSlice({
    name : "liveGame",
    initialState : {
        isLoading: false,
        error: null,
        messages: [],
        liveGameMedia: [],
        leaderboardDetails: {
            leaderboard: [],
            pageNumber: 1,
            pagePages: 0,
            pageSize: 10,
            totalRecords: 0,
        },
        fullGameLeaderboardDetails: {
            leaderboard: [],
            pageNumber: 1,
            pagePages: 0,
            pageSize: 10,
            totalRecords: 0,
        }
    },
    reducers: {

        appendMessage: (state, action) => {
            state.messages.push(action.payload);
        },
        updateLiveMessage: (state, action) => {
            const _messages = [...state.messages];
            const { messageId, attachmentURLs } = action.payload;

            if(attachmentURLs) {
                const index = _messages?.findIndex(message => message._id === messageId);
                console.log("FINDING MEDIA", index)
                if(index > -1) {
                    _messages[index].attachmentURLs = attachmentURLs;
                }
            }

            state.messages = [..._messages];
        },
        deleteLiveMessage: (state, action) => {
            const _messages = [...state.messages];
            const { messageId } = action.payload;

            const index = _messages?.findIndex(message => message._id === messageId);
            if(index > -1){
                _messages.splice(index, 1);
            }

            state.messages = _messages;
        },
        appendMedia: (state, action) => {
            state?.liveGameMedia?.mediaList.push(action.payload);
        },
        removeMediaMessage: (state, action) => {
            if (state.liveGameMedia?.mediaList) {
                state.liveGameMedia.mediaList = state.liveGameMedia.mediaList.filter(
                    media => media._id !== action.payload
                );
            }
        },
        pushToLeaderboard: (state, action) => {
            if(action.payload) {
                state.leaderboardDetails.leaderboard.push(action.payload);
            }
        },
        updateLeaderboard: (state, action) => {
            const arr = [...action.payload];
            state.leaderboardDetails.leaderboard = [...arr];
        },
        resetLeaderboard: (state) => {
            state.leaderboardDetails.leaderboard = [];
        },
        resetFullLeaderboard: (state) => {
            state.fullGameLeaderboardDetails.leaderboard = [];
        }
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getMessages, "messages", "error", "messageLoading");
        handleAsyncThunk(builder, sendMessage, "sendMessage", "error", "sendingMessage");
        handleAsyncThunk(builder, getLeaderboardDetails, "leaderboardDetails", "error", "leaderboardLoading");
        handleAsyncThunk(builder, getAllLeaderboardDetails, "fullGameLeaderboardDetails", "error", "fullLeaderboardLoading");
        handleAsyncThunk(builder, uploadMediaInLiveGame, "uploadMediaInLiveGame", "error", "uploadingMedia");
        handleAsyncThunk(builder, deleteLiveGameMedia, "deleteLiveGameMedia", "error", "deletingMessage");
        handleAsyncThunk(builder, restartLiveGame, "restartLiveGame", "error", "restartingGame");
        handleAsyncThunk(builder, getGameActionsListCorrespondingToZone, "gameZoneDetails", "error", "gameZoneDetailsLoading");
        handleAsyncThunk(builder, getLiveGameMediaList, "liveGameMedia", "error", "mediaLoading");
    },
});

export const { appendMessage, removeMediaMessage, pushToLeaderboard, updateLeaderboard, deleteLiveMessage, updateLiveMessage, resetLeaderboard, resetFullLeaderboard, appendMedia } = liveGameSlice.actions;

export default liveGameSlice.reducer;